var image_upload_default = {
  "container": "vt7kf",
  "disabled": "kDmcv",
  "imageInput": "_7NrDK",
  "overlay": "_4epyk",
  "text": "_6qkxO",
  "shown": "AmV0Q",
  "hide": "LVvaL",
  "spinner": "G60u9",
  "spin": "pW2Ru"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
